/**
 * 将接口下发的译制完成度规范为 0–100 的整数；未返回或无效时为 null。
 * 不在此处做任务列表推算或其它本地推断。
 */
export function normalizeCompletionPercent(value: unknown): number | null {
  if (value === null || value === undefined) return null;
  const n = Number(value);
  if (!Number.isFinite(n)) return null;
  return Math.min(100, Math.max(0, Math.round(n)));
}
